import React from 'react';
import Grid from '@mui/material/Grid';
import Style from './Styles/ShoppingCartItemStyle';
import Settings from '../../Settings/Settings'
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteShoppingCartItemDialog from './DeleteShoppingCartItemDialog';
import TextField from '@mui/material/TextField';

export default function ShoppingCartItem(props) {
    const classes = Style();
    const [quantity, setQuantity] = React.useState(parseInt(props.element.shoppingCartItemsQuantity));
    const [initialQuantity, setInitialQuantity] = React.useState(parseInt(props.element.shoppingCartItemsQuantity))
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false)
    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }

    const componentProps = {
        ...props.componentProps
    }

    const handleChangeQuantity = (event) => {
        if(event.target.value)
            setQuantity(parseInt(event.target.value))
        else
            setQuantity('')
    }

  const getShoppingCartTotal = () => {
      let accountToken = ''
      if(componentMethods.getLocalStorage('user')) {
          accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash;
      }
      componentMethods.ajax(Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCART_TOTAL + componentMethods.getLocalStorage('shoppingCart').shoppingCartSha + accountToken, {},'GET','addresses', (data) => {
          componentMethods.setManagerState({shoppingCartTotal: data.items.total})
      })
  }

    const putShoppingCartItemAction = () => {
        let url = Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCARTITEMS + componentMethods.getLocalStorage('shoppingCart').shoppingCartSha + '/' + props.element.shoppingCartItemsID
        let accountToken = ''
        if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
        }

        componentMethods.setManagerState({loadingShoppingCartItems: true, shoppingCartItems: []}, () => {
            componentMethods.ajax(url += accountToken, 
                {
                    shoppingCartItemsQuantity: quantity
                }, 
               "PUT", 'shoppingCartItems', 
                (data) => {
                   componentMethods.getShoppingCartItemsAction()
                   getShoppingCartTotal()
               })
        })
    }

  return (<React.Fragment>
      <DeleteShoppingCartItemDialog setOpenDeleteDialog={setOpenDeleteDialog} openDeleteDialog={openDeleteDialog} element={props.element} componentMethods={componentMethods} componentConstants={componentConstants} componentProps={componentProps} />
      <Grid container spacing={3}>
            <Grid item xs={5} lg={5} md={5}>
            <Typography component="div" variant="subtitle2" gutterBottom>{props.element.shopProductsArticleName}</Typography>
                <Typography component="div" variant="subtitle2" gutterBottom>{parseInt(props.element.shoppingCartItemsQuantity) * parseInt(props.element.shopProductsListPriceConverted) / 100} {componentConstants.language.LANG_CURRENCY}</Typography>
                <Typography component="div" variant="subtitle2" gutterBottom>{componentConstants.language.LANG_PRODUCT_CODE}: {props.element.shopProductsArticleId}</Typography>
            </Grid>
            <Grid item xs={2} lg={2} md={2}>
            <TextField
                fullWidth
                    label={componentConstants.language.LANG_QUANTITY}
                    type="search"
                    variant="standard"
                    value={quantity}
                    onChange={handleChangeQuantity}
                />
            </Grid>
            <Grid item xs={5} lg={5} md={5}>
                <IconButton disabled={initialQuantity === quantity} onClick={putShoppingCartItemAction} color="secondary" component="span">
                    <SaveIcon />
                </IconButton>
                <IconButton color="secondary" component="span" onClick={() => {setOpenDeleteDialog(true) }}>
                    <DeleteIcon />
                </IconButton>
            </Grid>
        </Grid>
        <Divider variant="middle" style={classes.divider} />
        </React.Fragment>
  );
}